import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EventEmitter,
  HostListener,
  inject,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';
import { LnMainMenuComponent } from '@components/menu/main-menu/main-menu.component';
import { LnLogoSvgIconComponent } from '@components/svg-icons/ln-logo-svg-icon/ln-logo-svg-icon.component';
import { LnSearchBarComponent } from '@components/ln-search-bar/ln-search-bar.component';
import { SearchBarValue } from '@core/services/search-bar-value/search-bar-value';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-top-banner-search-menu',
  imports: [LnLogoSvgIconComponent, LnSearchBarComponent, LnMainMenuComponent, LnMainMenuComponent, NgClass],
  templateUrl: './ln-top-banner-search-menu.component.html',
  styleUrl: './ln-top-banner-search-menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnTopBannerSearchMenuComponent {
  @Output() logoClicked = new EventEmitter<void>();
  showSearchBarOnDemand: WritableSignal<boolean> = signal(false);
  private searchBarValue = inject(SearchBarValue);
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;
  constructor() {
    effect(() => {
      const searchBarValue = this.searchBarValue.searchBarValue();
      if (searchBarValue !== '' && window.innerWidth <= 640) {
        this.showSearchBarOnDemand.set(true);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onScreenResize() {
    if (window.innerWidth > 640) {
      this.showSearchBarOnDemand.set(false);
    }
  }

  OnLogoClicked() {
    this.logoClicked.emit();
  }
}
